import React, { useState } from 'react';
import { Modal } from './Modal';
export function LegalFooter() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <div className="w-full bg-bg-primary border-t border-accent-primary border-opacity-10 py-4 px-4" data-id="element-152">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6 text-sm" data-id="element-153">
          <button onClick={() => setShowPrivacy(true)} className="text-text-secondary hover:text-accent-primary transition-colors" data-id="element-154">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline text-text-secondary" data-id="element-155">|</span>
          <button onClick={() => setShowTerms(true)} className="text-text-secondary hover:text-accent-primary transition-colors" data-id="element-156">
            Términos y Condiciones
          </button>
        </div>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-157">
        <div className="prose prose-invert max-w-none" data-id="element-158">
          <div className="space-y-6 text-text-secondary" data-id="element-159">
            <p className="text-sm text-text-secondary mb-8" data-id="element-160">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <section data-id="element-161">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-162">
                1. Información que Recopilamos
              </h3>
              <p className="leading-relaxed" data-id="element-163">
                Al adquirir "Arquitectura Empresarial USA: El Ecosistema de los
                4 Pilares", recopilamos información necesaria para procesar tu
                compra y entregarte el producto digital:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-164">
                <li data-id="element-165">Nombre y dirección de correo electrónico</li>
                <li data-id="element-166">
                  Información de pago (procesada de forma segura por nuestro
                  procesador de pagos)
                </li>
                <li data-id="element-167">
                  Dirección IP y datos de navegación para prevención de fraude
                </li>
              </ul>
            </section>

            <section data-id="element-168">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-169">
                2. Uso de la Información
              </h3>
              <p className="leading-relaxed" data-id="element-170">
                Utilizamos tu información exclusivamente para:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-171">
                <li data-id="element-172">Procesar tu compra y entregarte el ebook en formato PDF</li>
                <li data-id="element-173">Enviarte el enlace de descarga y confirmación de compra</li>
                <li data-id="element-174">Proporcionar soporte técnico si lo solicitas</li>
                <li data-id="element-175">Cumplir con obligaciones legales y fiscales</li>
              </ul>
            </section>

            <section data-id="element-176">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-177">
                3. Protección de Datos
              </h3>
              <p className="leading-relaxed" data-id="element-178">
                Implementamos medidas de seguridad técnicas y organizativas para
                proteger tu información personal contra acceso no autorizado,
                pérdida o alteración. Toda la información de pago es procesada a
                través de plataformas seguras certificadas.
              </p>
            </section>

            <section data-id="element-179">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-180">
                4. Compartir Información
              </h3>
              <p className="leading-relaxed" data-id="element-181">
                No vendemos, alquilamos ni compartimos tu información personal
                con terceros, excepto:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-182">
                <li data-id="element-183">
                  Procesadores de pago necesarios para completar la transacción
                </li>
                <li data-id="element-184">Cuando sea requerido por ley o autoridades competentes</li>
              </ul>
            </section>

            <section data-id="element-185">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-186">
                5. Tus Derechos
              </h3>
              <p className="leading-relaxed" data-id="element-187">Tienes derecho a:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-188">
                <li data-id="element-189">Acceder a tu información personal</li>
                <li data-id="element-190">Solicitar corrección de datos inexactos</li>
                <li data-id="element-191">
                  Solicitar eliminación de tus datos (sujeto a obligaciones
                  legales)
                </li>
                <li data-id="element-192">Oponerte al procesamiento de tus datos</li>
              </ul>
            </section>

            <section data-id="element-193">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-194">
                6. Cookies y Tecnologías de Seguimiento
              </h3>
              <p className="leading-relaxed" data-id="element-195">
                Este sitio utiliza cookies esenciales para su funcionamiento y
                análisis básico de tráfico. No utilizamos cookies de publicidad
                o seguimiento de terceros.
              </p>
            </section>

            <section data-id="element-196">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-197">
                7. Cambios a esta Política
              </h3>
              <p className="leading-relaxed" data-id="element-198">
                Nos reservamos el derecho de actualizar esta política de
                privacidad. Los cambios significativos serán notificados a
                través del correo electrónico proporcionado en tu compra.
              </p>
            </section>

            <section data-id="element-199">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-200">
                8. Contacto
              </h3>
              <p className="leading-relaxed" data-id="element-201">
                Para ejercer tus derechos o consultas sobre privacidad,
                contáctanos a través de los canales proporcionados en tu
                confirmación de compra.
              </p>
            </section>
          </div>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-202">
        <div className="prose prose-invert max-w-none" data-id="element-203">
          <div className="space-y-6 text-text-secondary" data-id="element-204">
            <p className="text-sm text-text-secondary mb-8" data-id="element-205">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <section data-id="element-206">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-207">
                1. Aceptación de Términos
              </h3>
              <p className="leading-relaxed" data-id="element-208">
                Al adquirir "Arquitectura Empresarial USA: El Ecosistema de los
                4 Pilares", aceptas estos términos y condiciones en su
                totalidad. Si no estás de acuerdo, no procedas con la compra.
              </p>
            </section>

            <section data-id="element-209">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-210">
                2. Descripción del Producto
              </h3>
              <p className="leading-relaxed" data-id="element-211">
                Este producto es un ebook digital en formato PDF que proporciona
                información educativa sobre arquitectura empresarial para
                empresas estadounidenses. El contenido incluye:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-212">
                <li data-id="element-213">Guía completa de los 4 pilares empresariales</li>
                <li data-id="element-214">Checklist Maestro de Arquitectura Empresarial</li>
                <li data-id="element-215">Mapa de Ejecución paso a paso</li>
                <li data-id="element-216">Sistema Búnker Digital para organización documental</li>
                <li data-id="element-217">Procesos ejecutables y glosario empresarial</li>
              </ul>
            </section>

            <section data-id="element-218">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-219">
                3. Naturaleza Educativa
              </h3>
              <p className="leading-relaxed font-semibold text-text-primary" data-id="element-220">
                IMPORTANTE: Este ebook es material educativo exclusivamente.
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-221">
                <li data-id="element-222">
                  NO constituye asesoría legal, fiscal, financiera ni contable
                </li>
                <li data-id="element-223">NO reemplaza la consulta con profesionales licenciados</li>
                <li data-id="element-224">NO garantiza resultados específicos ni ingresos</li>
                <li data-id="element-225">
                  Debes consultar con abogados, CPAs y asesores para tu
                  situación específica
                </li>
              </ul>
            </section>

            <section data-id="element-226">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-227">
                4. Licencia de Uso
              </h3>
              <p className="leading-relaxed" data-id="element-228">
                Al comprar este ebook, obtienes una licencia personal, no
                transferible y no exclusiva para:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-229">
                <li data-id="element-230">Descargar y usar el contenido para tu uso personal</li>
                <li data-id="element-231">Implementar los sistemas descritos en tu propia empresa</li>
              </ul>
              <p className="leading-relaxed mt-3 font-semibold text-text-primary" data-id="element-232">
                NO está permitido:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-233">
                <li data-id="element-234">Compartir, revender o distribuir el ebook</li>
                <li data-id="element-235">Reproducir el contenido públicamente sin autorización</li>
                <li data-id="element-236">Usar el material para crear productos derivados</li>
                <li data-id="element-237">Eliminar marcas de propiedad intelectual</li>
              </ul>
            </section>

            <section data-id="element-238">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-239">
                5. Precio y Pago
              </h3>
              <p className="leading-relaxed" data-id="element-240">
                El precio del ebook es de $47 USD (pago único). El pago se
                procesa de forma segura a través de nuestro procesador de pagos.
                Una vez completado el pago, recibirás acceso inmediato al enlace
                de descarga.
              </p>
            </section>

            <section data-id="element-241">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-242">
                6. Política de Reembolso
              </h3>
              <p className="leading-relaxed" data-id="element-243">
                Debido a la naturaleza digital del producto y el acceso
                inmediato al contenido completo, no ofrecemos reembolsos una vez
                completada la descarga. Te recomendamos revisar cuidadosamente
                la descripción del producto antes de comprar.
              </p>
            </section>

            <section data-id="element-244">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-245">
                7. Propiedad Intelectual
              </h3>
              <p className="leading-relaxed" data-id="element-246">
                Todo el contenido del ebook, incluyendo texto, gráficos, diseño
                y estructura, está protegido por derechos de autor. Todos los
                derechos están reservados.
              </p>
            </section>

            <section data-id="element-247">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-248">
                8. Limitación de Responsabilidad
              </h3>
              <p className="leading-relaxed" data-id="element-249">
                El contenido se proporciona "tal cual" sin garantías de ningún
                tipo. No nos hacemos responsables por:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-250">
                <li data-id="element-251">
                  Decisiones empresariales tomadas basándose en el contenido
                </li>
                <li data-id="element-252">Resultados específicos o falta de resultados</li>
                <li data-id="element-253">
                  Cambios en leyes o regulaciones posteriores a la publicación
                </li>
                <li data-id="element-254">Errores u omisiones en el contenido</li>
              </ul>
            </section>

            <section data-id="element-255">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-256">
                9. Actualizaciones del Contenido
              </h3>
              <p className="leading-relaxed" data-id="element-257">
                Nos esforzamos por mantener el contenido actualizado, pero las
                leyes y regulaciones cambian constantemente. No garantizamos
                actualizaciones automáticas del ebook después de la compra.
              </p>
            </section>

            <section data-id="element-258">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-259">
                10. Jurisdicción
              </h3>
              <p className="leading-relaxed" data-id="element-260">
                Estos términos se rigen por las leyes aplicables. Cualquier
                disputa será resuelta en la jurisdicción correspondiente.
              </p>
            </section>

            <section data-id="element-261">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-262">
                11. Modificaciones
              </h3>
              <p className="leading-relaxed" data-id="element-263">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Los cambios no afectarán compras ya
                realizadas.
              </p>
            </section>

            <section data-id="element-264">
              <h3 className="text-xl font-semibold text-text-primary mb-3" data-id="element-265">
                12. Contacto
              </h3>
              <p className="leading-relaxed" data-id="element-266">
                Para preguntas sobre estos términos, contáctanos a través de los
                canales proporcionados en tu confirmación de compra.
              </p>
            </section>

            <div className="mt-8 p-6 bg-bg-card border border-accent-primary border-opacity-20 rounded-lg" data-id="element-267">
              <p className="text-sm text-text-primary font-semibold mb-2" data-id="element-268">
                Al completar tu compra, confirmas que:
              </p>
              <ul className="text-sm space-y-1" data-id="element-269">
                <li data-id="element-270">• Has leído y aceptado estos términos y condiciones</li>
                <li data-id="element-271">
                  • Entiendes que este es material educativo, no asesoría
                  profesional
                </li>
                <li data-id="element-272">
                  • Consultarás con profesionales licenciados para tu situación
                  específica
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Modal>
    </>;
}